import { BrowserAndTabletView } from 'components/DeviceDetect'
import React from 'react'
import {
  ProductGalleryDesktop,
  ProductGallery,
  ProductImageSlider,
  ProductPictureSmall,
} from './ProductImages.style'
import Slider, { Slide } from 'components/Slider'
import useProduct from 'store/SingleProductProvider'

const ImagesSlider = ({ images, large_images }) => {
  const sliderProps = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: true,
    customPaging: i => (
      <a href="##">
        <ProductPictureSmall src={images[i] || ''} />
      </a>
    ),
    dotsClass: 'slick-dots slick-thumb',
    arrows: false,
  }

  if (!Array.isArray(images)) return 'not images'
  if (!Array.isArray(large_images)) return 'not large images'

  return (
    <ProductImageSlider {...sliderProps}>
      {images.map((image, key) => (
        <div className="product-image" key={image}>
          <img src={image} alt="product" />
        </div>
      ))}
    </ProductImageSlider>
  )
}

export function DesktopProductImages() {
  const {
    product: { large_images },
    images,
  } = useProduct()

  return (
    <BrowserAndTabletView>
      <ProductGalleryDesktop>
        <ImagesSlider images={images} large_images={large_images} />
      </ProductGalleryDesktop>
    </BrowserAndTabletView>
  )
}

export function MobileProductImages() {
  const {
    product: { name },
    images,
  } = useProduct()

  return (
    <ProductGallery>
      <Slider>
        {(images || []).map(img => (
          <Slide key={img}>
            <img
              itemProp="image"
              className="product-image"
              src={img}
              alt={name}
            />
          </Slide>
        ))}
      </Slider>
    </ProductGallery>
  )
}
